import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';

import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';

export const baseUrl = '/organization';

interface ConsolidableEventsRequest {
  organizationId: number;
}

export interface loginextConfiguration {
  organizationId: number;
  organizationName: string;
  loginextEffectiveVisitingTime: number;
  loginextDeliveryDelay: number;
}

export interface WorkplanOrderConfigurationRequest {
  organizationId: number;
  organizationName: string;
  orderTag: string;
  orderVolumeUnit: string;
  useWorkplanOrders: boolean;
  workplanVisitValidationTime?: number;
  autoCreateWorkplanOnJobAssignment?: boolean;
  orderStatusIds: string;
}

export interface RouteConfigurationRequest {
  organizationId: number;
  organizationName: string;
  useCustomRouteConfiguration: boolean;
  routeUnitOfflineTime: number;
}

export const getOrganizationsListService = async (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.organization',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/get`, request);
};

export const getConsolidableEvents = async (
  request: ConsolidableEventsRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.consolidatedEvents',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/GetConsolidableEvents`, request);
};

export const getDowntimeReasons = async (
  request: ConsolidableEventsRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.downtimeReasons',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getDowntimeReasons`, request);
};

export const deleteOrganizationService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'organizations.organization',
    action: 'Delete',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/delete`, request);
};

export const saveOrganizationService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'organizations.organization',
    action: request.organizationId ? 'Edit' : 'Create',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/save`, request);
};

export const quickCreateOrganizationService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'organizations.organization',
    action: 'Create',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/quickCreate`, request);
};

export const getContactsService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'organizations.organization',
    action: 'Get',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getContacts`, request);
};

export const saveLoginextConfigurationService = (
  request: loginextConfiguration,
  configAction: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'organizations.activeLoginext',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configAction);
  return httpWebtrack.post(`${baseUrl}/saveLoginextConfiguration`, request);
};

export const saveWorkplanOrderConfigurationService = (
  request: WorkplanOrderConfigurationRequest,
  configAction: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'workplans.orderConfiguration',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configAction);
  return httpWebtrack.post(`${baseUrl}/saveWorkplanOrderConfiguration`, request);
};

export const saveRouteConfigurationService = (
  request: RouteConfigurationRequest,
  configAction: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.organizationName}`,
    object: 'routes.routeConfiguration',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configAction);
  return httpWebtrack.post(`${baseUrl}/saveRouteConfiguration`, request);
};

// Organization API Keys Services
const apiKeyBaseUrl = '/organizationApiKey';

export const getOrganizationApiKeysService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.apiKeys',
    action: 'Get',
    genderType: 'PluralFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${apiKeyBaseUrl}/get`, request);
};

export const generateOrganizationApiKeyService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.apiKey',
    action: 'Create',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${apiKeyBaseUrl}/generate`, request);
};

export const deactivateOrganizationApiKeyService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.apiKey',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${apiKeyBaseUrl}/deactivate`, request);
};

export const revealOrganizationApiKeyService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.apiKey',
    action: 'Get',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${apiKeyBaseUrl}/reveal`, request);
};

export const updateApiKeyDescriptionService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.apiKey',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${apiKeyBaseUrl}/updateDescription`, request);
};

// Organization MCP Keys Services
const mcpKeyBaseUrl = '/organizationMcpKey';

export const getOrganizationMcpKeysService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.mcpKey',
    action: 'Get',
    genderType: 'PluralFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${mcpKeyBaseUrl}/get`, request);
};

export const generateOrganizationMcpKeyService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.mcpKey',
    action: 'Create',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${mcpKeyBaseUrl}/generate`, request);
};

export const deactivateOrganizationMcpKeyService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.mcpKey',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${mcpKeyBaseUrl}/deactivate`, request);
};

export const updateMcpKeyDescriptionService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'organizations.mcpKey',
    action: 'Edit',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${mcpKeyBaseUrl}/updateDescription`, request);
};
